import { NavLink, Outlet } from "react-router-dom";
import { Activity } from "lucide-react";

const navItems = [
  { to: "/", label: "Dashboard", testId: "nav-dashboard", end: true },
  { to: "/workspace", label: "Workspace", testId: "nav-workspace" },
  { to: "/meeting-rooms", label: "Meeting Rooms", testId: "nav-meeting-rooms" },
  { to: "/insights", label: "Insights", testId: "nav-insights" },
  { to: "/reports", label: "Reports", testId: "nav-reports" },
  { to: "/how-it-works", label: "How It Works", testId: "nav-how-it-works" },
  { to: "/settings", label: "Settings", testId: "nav-settings" },
];

export default function Layout() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-700">
      <header
        className="sticky top-0 z-40 border-b border-slate-200 bg-white/80 backdrop-blur-md"
        data-testid="top-nav"
      >
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3" data-testid="brand">
            <div className="flex h-9 w-9 items-center justify-center rounded-md bg-blue-600 text-white">
              <Activity className="h-5 w-5" strokeWidth={2.4} />
            </div>
            <div className="leading-tight">
              <div className="font-heading text-base font-semibold tracking-tight text-slate-900">
                HQ Signal
              </div>
              <div className="text-xs text-slate-500">
                Workspace Measurement
              </div>
            </div>
          </div>
          <nav className="hidden items-center gap-1 md:flex" data-testid="primary-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={item.testId}
                className={({ isActive }) =>
                  [
                    "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                    isActive
                      ? "bg-blue-50 text-blue-700"
                      : "text-slate-600 hover:text-slate-900 hover:bg-slate-100",
                  ].join(" ")
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden items-center gap-3 md:flex" data-testid="header-account">
            <div className="text-right leading-tight">
              <div className="text-xs font-medium text-slate-900">
                Madison Tower
              </div>
              <div className="text-[11px] text-slate-500">
                3 floors · 300 workplaces
              </div>
            </div>
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-900 text-xs font-semibold text-white">
              MT
            </div>
          </div>
        </div>
        {/* mobile nav row */}
        <div
          className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-4 pb-2 md:hidden"
          data-testid="mobile-nav"
        >
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`${item.testId}-mobile`}
              className={({ isActive }) =>
                [
                  "whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium",
                  isActive
                    ? "bg-blue-50 text-blue-700"
                    : "text-slate-600 hover:bg-slate-100",
                ].join(" ")
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-8" data-testid="main">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white" data-testid="footer">
        <div className="mx-auto max-w-7xl px-4 py-6 text-xs text-slate-500 sm:px-6 lg:px-8">
          HQ Signal · Workspace Measurement Campaign · Anonymous presence
          analytics. All metrics are aggregated and de-identified.
        </div>
      </footer>
    </div>
  );
}
